export default {
  // 通用
  '首頁': 'ホーム',
  '網站導覽': 'サイトマップ',
  ':::': ':::',
  
  // 無障礙相關
  '跳到中間主要內容區': 'メインコンテンツへスキップ',
  '上方區塊': '上部セクション',
  '頁尾網頁資訊': 'フッター情報',
  
  // 字級設定
  '字級': 'フォントサイズ',
  '大': '大',
  '中': '中',
  '小': '小',
  
  // 語言選擇
  '語言選擇': '言語',
  '繁體中文': '繁體中文',
  'ENGLISH': 'ENGLISH',
  '日本語': '日本語',
  
  // 社交媒體
  'FB': 'FB',
  'IG': 'IG',
  'YOUTUBE': 'YOUTUBE',
  '另開新視窗': '新しいウィンドウで開く',
  '（另開新視窗）': '（新しいウィンドウで開く）',
  
  // 頁尾
  'TOP': 'TOP',
  'CopyRight©2026': 'CopyRight©2026',
  
  // 導航
  'Toggle navigation': 'ナビゲーションを切り替え',
  
  // Home 頁面
  '跳到中央內容區塊': 'メインコンテンツへスキップ',
  '特展活動專區': '特別展示エリア',
  '最新消息': '最新ニュース',
  'READ MORE': '続きを読む',
  '更多最新消息（另開新視窗）': 'もっとニュースを見る（新しいウィンドウで開く）',
  '活動行事曆': 'イベントカレンダー',
  '休館': '休館',
  '有活動!': 'イベントあり!',
  '活動': 'イベント',
  '活動名稱': 'イベント名',
  '活動日期': 'イベント日付',
  '活動地點': 'イベント場所',
  '未指定地點': '場所未定',
  ' 圖片': ' 画像',
  
  // 教案專區
  '教案專區': 'レッスンプラン',
  '登入帳號：': 'ログインアカウント：',
  '剩餘可登入次數：': '残りのログイン回数：',
  '剩餘時間：': '残り時間：',
  '登出': 'ログアウト',
  '載入中...': '読み込み中...',
  '教案檔案列表': 'レッスンプランファイル一覧',
  '#': '#',
  '檔案名稱': 'ファイル名',
  '副檔名': '拡張子',
  '檔案大小': 'ファイルサイズ',
  '操作': '操作',
  '下載': 'ダウンロード',
  '下載檔案': 'ファイルをダウンロード',
  '目前沒有可下載的檔案': 'ダウンロード可能なファイルがありません',
  '登入時間已到，請重新登入': 'セッションが期限切れです。再度ログインしてください',
  '無法載入檔案列表': 'ファイルリストを読み込めません',
  '載入檔案失敗，請稍後再試': 'ファイルの読み込みに失敗しました。後でもう一度お試しください',
  '下載失敗': 'ダウンロード失敗',
  '下載檔案失敗，請稍後再試': 'ファイルのダウンロードに失敗しました。後でもう一度お試しください',
  
  // 教案登入
  '登入': 'ログイン',
  '電子郵件': 'メールアドレス',
  '請輸入電子郵件': 'メールアドレスを入力してください',
  '密碼': 'パスワード',
  '請輸入密碼': 'パスワードを入力してください',
  '隱藏密碼': 'パスワードを隠す',
  '顯示密碼': 'パスワードを表示',
  '登入中...': 'ログイン中...',
  '請輸入電子郵件和密碼': 'メールアドレスとパスワードを入力してください',
  '請輸入有效的電子郵件格式': '有効なメールアドレス形式を入力してください',
  '登入失敗，請檢查您的電子郵件和密碼': 'ログインに失敗しました。メールアドレスとパスワードを確認してください',
  '登入失敗，請稍後再試': 'ログインに失敗しました。後でもう一度お試しください',
  
  // Post 記事ページ
  '檔案下載': 'ファイルダウンロード',
  '（必填）': '（必須）',
  '此表單已達填寫上限，無法繼續填寫。': 'このフォームは送信上限に達しており、これ以上の入力はできません。',
  '請輸入其他內容': 'その他の内容を入力してください',
  '未選擇': '未選択',
  '其他': 'その他',
  '檔案大小限制：': 'ファイルサイズ制限：',
  'MB': 'MB',
  '允許類型：': '許可されるタイプ：',
  '最小值：': '最小値：',
  '最大值：': '最大値：',
  '送出中...': '送信中...',
  '送出': '送信',
  '分享': '共有',
  '分享至X（另開新視窗）': 'Xで共有（新しいウィンドウで開く）',
  '分享至FB（另開新視窗）': 'Facebookで共有（新しいウィンドウで開く）',
  '驗證失敗': '検証失敗',
  '請檢查表單內容': 'フォームの内容を確認してください',
  '確定': 'OK',
  '成功！': '成功！',
  '表單已成功送出。您的資料已送出，請等候審核通知。': 'フォームが正常に送信されました。データが送信されました。承認通知をお待ちください。',
  '表單已成功送出，感謝您的填寫。': 'フォームが正常に送信されました。ご記入ありがとうございます。',
  '錯誤': 'エラー',
  '送出失敗，請稍後再試': '送信に失敗しました。後でもう一度お試しください',
  '連結已複製到剪貼簿': 'リンクがクリップボードにコピーされました',
  '複製失敗，請手動複製連結': 'コピーに失敗しました。リンクを手動でコピーしてください',
  '此欄位為必填': 'この項目は必須です',
  '請輸入有效的電子郵件地址': '有効なメールアドレスを入力してください',
  '請輸入有效的網址': '有効なURLを入力してください',
  '輸入格式不正確': '入力形式が正しくありません',
  '請輸入有效的數字': '有効な数字を入力してください',
  '數字不可小於': '数値は以下より小さくできません',
  '數字不可大於': '数値は以下より大きくできません',
  '檔案大小不可超過': 'ファイルサイズは超過できません',
  '僅允許上傳': '許可されているのは',
  '格式的檔案': '形式のファイルのみです',
  '檔案處理失敗，請重試': 'ファイル処理に失敗しました。もう一度お試しください',
  '附件': '添付ファイル',
  
  // 予約関連
  '參觀預約': '見学予約',
  '團體預約': '団体予約',
  '導覽預約': 'ガイドツアー予約',
  '預約紀錄查詢': '予約記録照会',
  '【導覽解說預約須知】': '【ガイドツアー予約に関する注意事項】',
  '隆田文化資產教育園區為全國第一座文化資產為主題之教育園區，並以「推廣臺南文化資產」、「文化資產教育資源整合」與「臺南文化資產國際交流」三大願景持續推進，提供導覽解說服務': '隆田文化資産教育パークは、全国初の文化遺産をテーマとした教育パークであり、「台南文化遺産の推進」、「文化遺産教育リソースの統合」、「台南文化遺産国際交流」という3つのビジョンを推進し、ガイドツアーサービスを提供しています。',
  '辦理【團體參觀預約】者（無導覽需求），請點選【團體預約】按鈕進入申請': '【団体見学予約】（ガイド不要）の方は、【団体予約】ボタンをクリックしてお申し込みください。',
  '辦理【導覽解說預約】者，請點選【導覽預約】按鈕進入申請': '【ガイドツアー予約】の方は、【ガイドツアー予約】ボタンをクリックしてお申し込みください。',
  '整日不開放': '終日休館',
  '已截止報名': '申込締切',
  '本日報名已額滿': '本日は満員です',
  '有限制人數': '人数制限あり',
  '無限制人數': '人数制限なし',
  
  // 予約フォーム
  '您所預約的日期為：': 'ご予約日：',
  '年': '年',
  '月': '月',
  '日': '日',
  '預約時間': '予約時間',
  '申請單位': '申請団体名',
  '請輸入申請單位': '申請団体名を入力してください',
  '單位類型': '団体タイプ',
  '學校機關': '学校・機関',
  '旅行業者': '旅行会社',
  '媒體記者': 'メディア・報道',
  '私人企業': '民間企業',
  '公務機關': '公的機関',
  '請輸入其他類型': 'その他のタイプを入力してください',
  '貴團年齡層分布(以最大宗為主)': '年齢層（最も多い層）',
  '幼稚園': '幼稚園',
  '國小': '小学校',
  '國中': '中学校',
  '高中': '高校',
  '大學(含研究所)': '大学（大学院を含む）',
  '社會人士': '一般社会人',
  '樂齡長者(65歲以上)': 'シニア（65歳以上）',
  '團體代表姓名': '団体代表者名',
  '請輸入參觀日聯絡人或導遊／領隊姓名': '見学日の連絡先またはガイド名を入力してください',
  '團體代表手機': '団体代表者電話番号',
  '請輸入參觀日聯絡人或導遊／領隊電話': '見学日の連絡先またはガイドの電話番号を入力してください',
  '參觀人數': '見学人数',
  '(長者及6歲以下學童皆須計算人數在內)': '（高齢者と6歳以下の子供も含めて計算してください）',
  '申請人姓名': '申請者名',
  '請輸入姓名': '名前を入力してください',
  '申請人身分證字號': '申請者ID番号',
  '請輸入身分證字號': 'ID番号を入力してください',
  '申請人手機': '申請者電話番号',
  '請輸入手機': '電話番号を入力してください',
  '申請人電子信箱': '申請者メールアドレス',
  '請輸入電子信箱': 'メールアドレスを入力してください',
  '預約備註': '備考',
  '請輸入預約備註': '備考を入力してください',
  '※ 若無法順利媒合導覽老師，將以電子信件或電話通知，故請確認聯繫資料填寫正確': '※ ガイドの手配ができない場合、メールまたは電話でお知らせします。連絡先情報が正確であることをご確認ください。',
  '※ 參觀當天請出示名冊並預先確認符合半票或免費入場資格者人數': '※ 見学当日は名簿を提示し、半額または無料入場資格者の人数を事前にご確認ください。',
  '我已經詳細閱讀並同意': '利用規約を読み、同意します',
  '使用規範': '利用規約',
  '使用規範（另開新視窗）': '利用規約（新しいウィンドウで開く）',
  '重選日期': '日付を再選択',
  '確認送出': '送信確認',
  
  // 予約フォーム検証
  '請選擇預約時間': '予約時間を選択してください',
  '請選擇單位類型': '団体タイプを選択してください',
  '請選擇年齡層': '年齢層を選択してください',
  '請輸入團體代表姓名': '団体代表者名を入力してください',
  '請輸入團體代表手機': '団体代表者電話番号を入力してください',
  '請輸入有效的手機號碼（格式：09XXXXXXXX）': '有効な電話番号を入力してください（形式：09XXXXXXXX）',
  '參觀人數須介於': '見学人数は',
  '人': '人',
  '請輸入有效的台灣身分證字號': '有効な台湾ID番号を入力してください',
  '請輸入有效的電子信箱': '有効なメールアドレスを入力してください',
  '請閱讀並同意使用規範後再送出': '利用規約を読み、同意してから送信してください',
  '請先選擇日期': '日付を選択してください',
  '請先選擇報名類型': '予約タイプを選択してください',
  '載入時段資訊失敗，請稍後再試': '時間帯の読み込みに失敗しました。後でもう一度お試しください',
  '報名成功！待管理員審核後將以電子郵件通知您': '申込成功！管理者の承認後、メールで通知します。',
  '報名失敗，請稍後再試': '申込に失敗しました。後でもう一度お試しください',
  '提交時發生錯誤，請稍後再試': '送信中にエラーが発生しました。後でもう一度お試しください',
  
  // 予約照会
  '查詢中...': '照会中...',
  '送出查詢': '照会送信',
  '查詢結果': '照会結果',
  '共': '合計：',
  '筆': '件',
  '查無符合的預約記錄': '該当する予約記録が見つかりません',
  '報名編號': '申込番号',
  '報名時間': '申込時間',
  '預約日期': '予約日',
  '預約時段': '時間帯',
  '報名類型': '予約タイプ',
  '審核狀態': '審査状況',
  '待審核': '審査待ち',
  '已通過': '承認済み',
  '未通過': '却下',
  '未知': '不明',
  '年齡層': '年齢層',
  '無限制': '制限なし',
  '備註': '備考',
  '審核時間': '審査時間',
  '審核說明': '審査コメント',
  '請輸入申請人電子信箱': '申請者のメールアドレスを入力してください',
  '請輸入申請人身分證字號': '申請者のID番号を入力してください',
  '查詢時發生錯誤，請稍後再試': '照会中にエラーが発生しました。後でもう一度お試しください',
  '申請人信箱': '申請者メール',
  
  // スタッフ/ボランティアログイン
  '員/志工登入': 'スタッフ/ボランティアログイン',
  '登入': 'ログイン',
  '電子郵件': 'メールアドレス',
  '請輸入電子郵件': 'メールアドレスを入力してください',
  '密碼': 'パスワード',
  '請輸入密碼': 'パスワードを入力してください',
  '隱藏密碼': 'パスワードを隠す',
  '顯示密碼': 'パスワードを表示',
  '登入中...': 'ログイン中...',
  '請輸入電子郵件和密碼': 'メールアドレスとパスワードを入力してください',
  '請輸入有效的電子郵件格式': '有効なメールアドレス形式を入力してください',
  '登入失敗，請檢查您的電子郵件和密碼': 'ログインに失敗しました。メールアドレスとパスワードを確認してください',
  '登入失敗，請稍後再試': 'ログインに失敗しました。後でもう一度お試しください',
  
  // サイトマップ
  '網站導覽': 'サイトマップ',
  '網站的主要樣版內容分為三個大區塊：': 'ウェブサイトの主要なテンプレートコンテンツは3つの大きなセクションに分かれています：',
  '(1)上方區塊 (2)中央內容區塊 (3)頁尾網頁資訊': '(1) トップセクション (2) 中央コンテンツセクション (3) フッター情報',
  '本網站的導盲磚﹝Accesskey,也稱為快速鍵﹞設定如下：': '本ウェブサイトのアクセスキー（ショートカットキーとも呼ばれます）は次のように設定されています：',
  'Alt +U：移至網頁最上方之項目位置。': 'Alt +U：ページの一番上に移動します。',
  'Alt +C：主要內容區，此區塊呈現網頁主要內容資訊。': 'Alt +C：メインコンテンツエリア、このセクションは主要なコンテンツ情報を表示します。',
  'Alt +B：下方頁尾網頁資訊。': 'Alt +B：ページ下部のフッター情報。',
  
  // 営業時間と料金
  '時間票價': '営業時間と料金',
  '營業時間': '営業時間',
  '星期': '曜日',
  '開館時間': '開館時間',
  '星期一': '月曜日',
  '星期二': '火曜日',
  '星期三': '水曜日',
  '星期四': '木曜日',
  '星期五': '金曜日',
  '星期六': '土曜日',
  '星期日': '日曜日',
  '09:00 – 17:00': '09:00 – 17:00',
  '10:00 – 17:00': '10:00 – 17:00',
  '休館': '休館',
  '最後售票時間及入園時間：16:30': '最終入場時間：16:30',
  '休園日：每週三、小年夜、除夕': '休園日：毎週水曜日、旧正月前夜（2日間）',
  '※營運調整公告：自2026年1月1日起，隆田文化資產教育園區每週固定休園日，調整為「每週三」': '※運営変更のお知らせ：2026年1月1日より、隆田文化財教育園は毎週水曜日を定休日といたします。',
  '票價資訊': '入場料',
  '票種': 'チケット種類',
  '票價': '料金',
  '適用對象': '対象者',
  '全票': '一般チケット',
  '優惠票': '割引チケット',
  '半票': '半額チケット',
  '免費': '無料',
  '一般遊客': '一般来場者',
  '持有學生證在學學生。': '有効な学生証をお持ちの学生。',
  '20人以上團體之成員。': '20名以上のグループメンバー。',
  '65歲以上長者。': '65歳以上の高齢者。',
  '6歲以上未滿12歲之兒童。': '6歳以上12歳未満の児童。',
  '持有設籍於本市官田區之身分證明文件。': '官田区の住民証明書をお持ちの方。',
  '未滿六歲之兒童。': '6歳未満のお子様。',
  '持有縣市政府依志願服務法之志願服務榮譽卡。': 'ボランティア名誉カードをお持ちの方。',
  '持有交通部觀光局核發之導遊人員執業證。': '有効なツアーガイド資格証をお持ちの方。',
  '持有身心障礙證明，其本人與隨同1人。': '障害者手帳をお持ちの方と同伴者1名。',
  '※凡購買優惠票、半票及免費票條件者，敬請出示相關證件，未攜帶者一律依全票計。': '※割引、半額、無料チケットの対象の方は有効な証明書をご提示ください。提示がない場合は通常料金となります。',
  '※為鼓勵乘坐大眾交通運輸工具，如於園區服務台出示 T-Pass 或當日臺鐵隆田站下車之乘車證明或車票，即可享門票優惠價（70元）購票入園！': '※公共交通機関のご利用を推奨しております。サービスカウンターにてT-Passまたは当日の台湾鉄道隆田駅の乗車証明または切符をご提示いただくと、割引料金（70元）でご入場いただけます！',
  
  // スケジュール管理
  '排班列表': 'シフト一覧',
  '員工': 'スタッフ',
  '志工': 'ボランティア',
  '員/志工排班': 'スタッフ/ボランティアシフト',
  '今日無勤務': '本日勤務なし',
  '員工公告': 'スタッフお知らせ',
  '志工公告': 'ボランティアお知らせ',
  '排班期間': 'シフト期間',
  '未開放排班': '受付前',
  '排班中': '受付中',
  '排班已截止': '受付終了',
  '開放排班時間': 'シフト受付期間',
  '已送出': '提出済み',
  '暫存中': '下書き',
  '未送出': '未提出',
  '預計時數': '予定時間',
  '小時': '時間',
  '實際時數': '実績時間',
  '開始排班': 'シフト入力開始',
  '檢視排班': 'シフト確認',
  '尚未開放': '未受付',
  '目前沒有可排班的項目': '現在利用可能なシフトはありません',
  '載入排班列表失敗': 'シフト一覧の読み込みに失敗しました',
  '載入排班列表失敗，請稍後再試': 'シフト一覧の読み込みに失敗しました。後でもう一度お試しください',
  
  // 打刻
  '上午打卡': '午前出勤',
  '上午打卡(下班)': '午前退勤',
  '上午打卡(完成)': '午前完了',
  '下午打卡': '午後出勤',
  '下午打卡(下班)': '午後退勤',
  '下午打卡(完成)': '午後完了',
  '已超過打卡時間': '打刻時間を超過',
  '上午打卡時間已過': '午前の打刻時間が過ぎました',
  '未達可打卡時間': '打刻時間前',
  '下午打卡時間尚未到': '午後の打刻時間はまだです',
  '下午打卡時間已過': '午後の打刻時間が過ぎました',
  '打卡成功': '打刻成功',
  '打卡失敗': '打刻失敗',
  '打卡失敗，請稍後再試': '打刻に失敗しました。後でもう一度お試しください',
  '確認下班': '退勤確認',
  '確定要下班打卡嗎？': '退勤打刻してもよろしいですか？',
  '系統將計算您的工作時數': 'システムが勤務時間を計算します',
  '已執勤：': '勤務時間：',
  '分鐘': '分',
  '下班打卡成功': '退勤打刻成功',
  
  // スタッフシフト
  '員工排班表': 'スタッフシフト表',
  '剩餘需排休假日：': '残りの休息日：',
  '剩餘需排例假日：': '残りの定休日：',
  '可上班日': '勤務可能日',
  '休息日(可加班)': '休息日（残業可）',
  '例假日(不可加班)': '定休日（残業不可）',
  '員工姓名': 'スタッフ名',
  '注意事項': '注意事項',
  '國定假日，不可同時休假。': '国民の祝日には、全員が同時に休暇を取ることはできません。',
  '*如遇天然災害，依本市公佈放假標準為原則。': '*自然災害の場合は、市が発表する休業基準に従います。',
  '暫存': '下書き保存',
  '返回列表': '一覧に戻る',
  '無效的排班 ID': '無効なシフトID',
  '載入排班資料失敗，請稍後再試': 'シフトデータの読み込みに失敗しました。後でもう一度お試しください',
  '暫存成功': '下書き保存成功',
  '暫存失敗': '下書き保存失敗',
  '休息日超過限制': '休息日が超過',
  '休息日不足': '休息日が不足',
  '例假日超過限制': '定休日が超過',
  '例假日不足': '定休日が不足',
  '確定要送出排班嗎？送出後將無法修改': 'シフトを提出してもよろしいですか？提出後は変更できません。',
  '取消': 'キャンセル',
  '儲存失敗': '保存失敗',
  '儲存排班資料失敗': 'シフトデータの保存に失敗しました',
  '送出成功': '提出成功',
  '您的排班已成功送出': 'シフトが正常に提出されました',
  '已達上限': '上限に達しました',
  
  // スタッフシフト管理
  '管理員工班表': 'スタッフシフト管理',
  '管理者模式': '管理者モード',
  '管理者模式：可不受時間限制調整所有員工的排班': '管理者モード：時間制限なしで全スタッフのシフトを調整可能',
  '儲存': '保存',
  '確認儲存': '保存確認',
  '確定要儲存所有員工的排班嗎？': '全スタッフのシフトを保存してもよろしいですか？',
  '確定儲存': '保存確定',
  '儲存成功': '保存成功',
  '所有員工的排班已成功儲存': '全スタッフのシフトが正常に保存されました',
  '無效的存取方式': '無効なアクセス方法',
  
  // ボランティア申込
  '志工申請': 'ボランティア申込',
  '志工申請表': 'ボランティア応募フォーム',
  '基本資訊': '基本情報',
  '電子信箱': 'メールアドレス',
  '請輸入電子信箱': 'メールアドレスを入力してください',
  '出生年月日': '生年月日',
  '性別': '性別',
  '男': '男性',
  '女': '女性',
  '身份證字號': 'ID番号',
  '請輸入身份證字號': 'ID番号を入力してください',
  '照片': '写真',
  '選擇照片': '写真を選択',
  '已選擇：': '選択済み：',
  '支援格式: JPG, PNG / 檔案大小上限: 5MB': '対応形式：JPG、PNG / 最大ファイルサイズ：5MB',
  '學校': '学校',
  '請輸入學校名稱': '学校名を入力してください',
  '系所': '学部',
  '請輸入系所名稱': '学部名を入力してください',
  '肄業/畢業': '在学/卒業',
  '請選擇': '選択してください',
  '肄業': '在学中',
  '畢業': '卒業',
  '婚姻狀況': '婚姻状況',
  '已婚': '既婚',
  '未婚': '未婚',
  '戶籍地址': '住民登録住所',
  '請輸入戶籍地址': '住民登録住所を入力してください',
  '通訊地址': '現住所',
  '同戶籍地址': '住民登録住所と同じ',
  '請輸入通訊地址': '現住所を入力してください',
  '聯絡方式': '連絡先情報',
  '住家電話': '自宅電話',
  '請輸入住家電話': '自宅電話を入力してください',
  '辦公電話': '勤務先電話',
  '請輸入辦公電話': '勤務先電話を入力してください',
  '手機': '携帯電話',
  '請輸入手機號碼': '携帯電話番号を入力してください',
  '※ 住家電話、辦公電話、手機三者至少需填寫一個': '※ 自宅電話、勤務先電話、携帯電話のいずれか1つは必須です',
  '就業/就學狀況': '就業/就学状況',
  '就業/就學狀態': '就業/就学状態',
  '就業中': '就業中',
  '就學中': '就学中',
  '退休': '退職',
  '就業單位': '勤務先',
  '請輸入就業單位': '勤務先を入力してください',
  '就讀學校': '在学中の学校',
  '請輸入就讀學校': '在学中の学校を入力してください',
  '其他狀態說明': 'その他の状態説明',
  '請說明其他狀態': 'その他の状態を説明してください',
  '志工經驗': 'ボランティア経験',
  '過去志工經驗': '過去のボランティア経験',
  '請描述過去的志工經驗': '過去のボランティア経験を記述してください',
  '目前志工經驗': '現在のボランティア経験',
  '請描述目前的志工經驗': '現在のボランティア経験を記述してください',
  '志願服務手冊': 'ボランティア手帳',
  '有': 'あり',
  '無': 'なし',
  '專長與興趣': '専門分野と興味',
  '專長': '専門分野',
  '導覽解說': 'ガイド解説',
  '藝術文學': '芸術文学',
  '歷史人文': '歴史人文',
  '水電木工': '水道電気大工',
  '動物生態': '動物生態',
  '植物生態': '植物生態',
  '電腦美工': 'コンピュータグラフィックス',
  '攝影繪圖': '写真・イラスト',
  '電腦文書': 'パソコン文書',
  '護理急救': '看護救急',
  '請說明其他專長': 'その他の専門分野を説明してください',
  '興趣': '興味',
  '請描述您的興趣': 'あなたの興味を記述してください',
  '語言能力': '言語能力',
  '華語': '中国語',
  '英語': '英語',
  '臺語': '台湾語',
  '日語': '日本語',
  '精通': '流暢',
  '中等': '中級',
  '略懂': '初級',
  '不會': 'なし',
  '其他語言': 'その他の言語',
  '有其他語言能力': 'その他の言語能力あり',
  '語言名稱': '言語名',
  '請選擇程度': '熟練度を選択してください',
  '申請動機': '応募動機',
  '回饋社會，服務他人': '社会への還元、他者への奉仕',
  '吸收藝文新知': '芸術文化の知識吸収',
  '精神生活樂趣': '精神生活の楽しみ',
  '交新朋友': '新しい友達を作る',
  '打發空閒時間': '余暇時間の活用',
  '磨練自己': '自己研鑽',
  '請說明其他動機': 'その他の動機を説明してください',
  '健康狀況': '健康状態',
  '特殊疾病': '特別な病気',
  '請說明疾病狀況': '病状を説明してください',
  '可服勤時段': '勤務可能時間帯',
  '星期/時間': '曜日/時間',
  '09時-12時': '09:00-12:00',
  '13時-16時': '13:00-16:00',
  '休館日': '休館日',
  '請依照優先順序勾選可服勤時段，系統會自動標注順序號碼': '優先順位に従って勤務可能時間帯を選択してください。システムが自動的に番号を付けます',
  '其他資訊': 'その他の情報',
  '自我介紹': '自己紹介',
  '請簡單介紹您自己': '簡単に自己紹介してください',
  '我已經詳細閱讀個人資料使用同意書並同意相關規範': '個人情報使用同意書を詳しく読み、関連規定に同意します',
  '下載個人資料使用同意書': '個人情報使用同意書をダウンロード',
  '返回首頁': 'ホームに戻る',
  '文章不存在': '記事が見つかりません',
  '確認送出': '送信確認',
  '送出中...': '送信中...',
  '照片檔案大小不得超過 5MB': '写真ファイルサイズは5MBを超えてはいけません',
  '請選擇有效的圖片檔案 (JPG, PNG, GIF)': '有効な画像ファイル（JPG、PNG、GIF）を選択してください',
  '請輸入有效的台灣身分證字號': '有効な台湾ID番号を入力してください',
  '住家電話、辦公電話、手機三者至少需填寫一個': '自宅電話、勤務先電話、携帯電話のいずれか1つは必須です',
  '請輸入有效的手機號碼（格式：09XXXXXXXX）': '有効な携帯電話番号を入力してください（形式：09XXXXXXXX）',
  '請選擇就業/就學狀態': '就業/就学状態を選択してください',
  '請選擇是否有志願服務手冊': 'ボランティア手帳の有無を選択してください',
  '請選擇華語能力': '中国語能力を選択してください',
  '請選擇英語能力': '英語能力を選択してください',
  '請選擇臺語能力': '台湾語能力を選択してください',
  '請選擇日語能力': '日本語能力を選択してください',
  '請至少選擇一個可服勤時段': '少なくとも1つの勤務可能時間帯を選択してください',
  '請填寫自我介紹': '自己紹介を記入してください',
  '請閱讀並同意相關規範後再送出': '関連規定を読み、同意してから送信してください',
  '申請成功！我們將於審核後與您聯繫': '応募成功！審査後にご連絡します',
  '申請失敗，請稍後再試': '応募に失敗しました。後でもう一度お試しください',
  '提交時發生錯誤，請稍後再試': '送信中にエラーが発生しました。後でもう一度お試しください',
  
  // ボランティアシフト
  '志工排班表': 'ボランティアシフト表',
  '上午場': '午前シフト',
  '下午場': '午後シフト',
  '全日': '終日',
  '星期四至星期二上午9時至12時及下午1時至4時，採兩班制。': '木曜日から火曜日まで、午前9時～12時と午後1時～4時の2交代制です。',
  '*如遇天然災害，依本市公佈放假標準為原則，不另行通知。': '*自然災害の場合は、市が発表する休業基準に従います。別途通知はありません。',
  '逾時未打卡': '時間超過未打刻',
  '打卡: ': '打刻：',
  
  // ボランティアシフト管理
  '管理志工班表': 'ボランティアシフト管理',
  '管理者模式：可不受時間限制調整所有志工的排班，但依然會照志工的可服勤時段有所限制': '管理者モード：時間制限なしで全ボランティアのシフトを調整可能ですが、ボランティアの勤務可能時間帯による制限があります',
  '志工姓名': 'ボランティア名',
  '確定要儲存所有志工的排班嗎？': '全ボランティアのシフトを保存してもよろしいですか？',
  '所有志工的排班已成功儲存': '全ボランティアのシフトが正常に保存されました',
  
  // 共通
  '天': '日',
  '請移除': '削除してください',
  '還需要選擇': 'さらに選択が必要です',
  '個人資訊': '個人情報',
  '請選擇出生年月日': '生年月日を選択してください',
  '請選擇性別': '性別を選択してください',
  '請輸入身份證字號': 'ID番号を入力してください',
  '請上傳照片': '写真をアップロードしてください',
  '請輸入學校': '学校を入力してください',
  '請輸入系所': '学部を入力してください',
  '請選擇肄業/畢業': '在学/卒業を選択してください',
  '請選擇婚姻狀況': '婚姻状況を選択してください',
  '請輸入戶籍地址': '住民登録住所を入力してください',
  '請輸入通訊地址': '現住所を入力してください',
  'ㄠ輸入就業單位': '勤務先を入力してください',
  '請輸入就讀學校': '在学中の学校を入力してください',
  '請說明其他狀態': 'その他の状態を説明してください',
  '請輸入語言名稱': '言語名を入力してください',
  '請選擇語言程度': '言語レベルを選択してください',
  '請選擇是否有特殊疾病': '特別な病気の有無を選択してください',
  '確定送出': '送信確定',
  '休息日已達上限': '休息日の上限に達しました',
  '例假日已達上限': '定休日の上限に達しました',
  '無法再新增': 'これ以上追加できません',
  '的排班失敗': 'のシフト保存失敗',
  '儲存失敗，請稍後再試': '保存に失敗しました。後でもう一度お試しください',
  
  // ボランティア申請追加分
  '志工申請': 'ボランティア申請',
  '肄業/畢業': '在籍/卒業',
  '請選擇': '選択してください',
  '肄業': '在籍',
  '畢業': '卒業',
  '婚姻狀況': '婚姻状況',
  '已婚': '既婚',
  '未婚': '未婚',
  '戶籍地址': '本籍地住所',
  '通訊地址': '連絡先住所',
  '同戶籍地址': '本籍地住所と同じ',
  '住家電話': '自宅電話',
  '請輸入住家電話': '自宅電話を入力してください',
  '辦公電話': '会社電話',
  '請輸入辦公電話': '会社電話を入力してください',
  '請輸入手機號碼': '携帯電話番号を入力してください',
  '※ 住家電話、辦公電話、手機三者至少需填寫一個': '※ 自宅電話、会社電話、携帯電話のうち少なくとも1つを入力してください',
  '就業/就學狀況': '就業/就学状況',
  '就業/就學狀態': '就業/就学状態',
  '就業中': '就業中',
  '就學中': '就学中',
  '退休': '退職',
  '就業單位': '勤務先',
  '就讀學校': '通学先',
  '其他狀態說明': 'その他の状態説明',
  '過去志工經驗': '過去のボランティア経験',
  '請描述過去的志工經驗': '過去のボランティア経験を説明してください',
  '目前志工經驗': '現在のボランティア経験',
  '請描述目前的志工經驗': '現在のボランティア経験を説明してください',
  '專長': '特技',
  '請說明其他專長': 'その他の特技を説明してください',
  '興趣': '趣味',
  '請描述您的興趣': 'ご趣味を説明してください',
  '華語': '中国語',
  '英語': '英語',
  '臺語': '台湾語',
  '日語': '日本語',
  '精通': '堪能',
  '中等': '中級',
  '略懂': '初級',
  '不會': 'なし',
  '其他語言': 'その他の言語',
  '有其他語言能力': 'その他の言語能力あり',
  '語言名稱': '言語名',
  '特殊疾病': '特殊疾患',
  '請說明疾病狀況': '病状を説明してください',
  '星期/時間': '曜日/時間',
  '09時-12時': '09時-12時',
  '13時-16時': '13時-16時',
  '請依照優先順序勾選可服勤時段，系統會自動標注順序號碼': '優先順位に従って勤務可能時間帯を選択してください。システムが自動的に順序番号を付けます',
  '自我介紹': '自己紹介',
  '請簡單介紹您自己': '簡単に自己紹介してください',
  '我已經詳細閱讀個人資料使用同意書並同意相關規範': '個人情報使用同意書を詳しく読み、関連規範に同意します',
  '下載個人資料使用同意書': '個人情報使用同意書をダウンロード',
  '返回首頁': 'ホームに戻る',
  '照片檔案大小不得超過 5MB': '写真ファイルサイズは5MBを超えてはいけません',
  '請選擇有效的圖片檔案 (JPG, PNG, GIF)': '有効な画像ファイルを選択してください (JPG, PNG, GIF)',
  '請輸入有效的台灣身分證字號': '有効な台湾ID番号を入力してください',
  '請上傳照片': '写真をアップロードしてください',
  '請輸入學校': '学校を入力してください',
  '請輸入系所': '学部を入力してください',
  '請選擇肄業/畢業': '在籍/卒業を選択してください',
  '住家電話、辦公電話、手機三者至少需填寫一個': '自宅電話、会社電話、携帯電話のうち少なくとも1つを入力してください',
  '請選擇就業/就學狀態': '就業/就学状態を選択してください',
  '請選擇是否有志願服務手冊': 'ボランティアサービス手帳の有無を選択してください',
  '請選擇華語能力': '中国語能力を選択してください',
  '請選擇英語能力': '英語能力を選択してください',
  '請選擇臺語能力': '台湾語能力を選択してください',
  '請選擇日語能力': '日本語能力を選択してください',
  '請至少選擇一個可服勤時段': '少なくとも1つの勤務可能時間帯を選択してください',
  '請填寫自我介紹': '自己紹介を記入してください',
  '申請成功！我們將於審核後與您聯繫': '申請成功！審査後にご連絡いたします',
  '申請失敗，請稍後再試': '申請に失敗しました。後でもう一度お試しください',
  '請輸入就業單位': '勤務先をご入力ください',
  '請輸入就讀學校': '在学校をご入力ください',
  '請輸入有效的手機號碼（格式：09XXXXXXXX）': '有効な携帯番号を入力してください（形式：09XXXXXXXX）',
  '請選擇肄業/畢業': '在籍/卒業を選択してください',
  '請輸入學校': '学校名をご入力ください',
  '請輸入系所': '学科をご入力ください',
  '請輸入有效的台灣身分證字號': '有効な台湾身分証番号をご入力ください',
  '請上傳照片': '写真をアップロードしてください',
  '請輸入電子信箱': 'メールアドレスをご入力ください',
  '請輸入有效的電子信箱': '有効なメールアドレスをご入力ください',
  '請輸入姓名': 'お名前をご入力ください',
  '請選擇出生年月日': '生年月日を選択してください',
  '請選擇性別': '性別を選択してください',
  '請輸入身份證字號': '身分証番号をご入力ください',
  '請選擇婚姻狀況': '婚姻状況を選択してください',
  '請輸入戶籍地址': '戸籍住所をご入力ください',
  '請輸入通訊地址': '連絡先住所をご入力ください',
  '住家電話、辦公電話、手機三者至少需填寫一個': '自宅電話、会社電話、携帯電話のうち少なくとも一つご記入ください',
  '請選擇就業/就學狀態': '就業/就学状況を選択してください',
  '請說明其他狀態': 'その他の状況をご説明ください',
  '請選擇是否有志願服務手冊': 'ボランティア手帳をお持ちかお選びください',
  '請選擇華語能力': '中国語能力を選択してください',
  '請選擇英語能力': '英語能力を選択してください',
  '請輸入語言名稱': '言語名をご入力ください',
  '請選擇語言程度': '言語レベルを選択してください',
  '請選擇是否有特殊疾病': '特別な疾患の有無を選択してください',
  '請說明疾病狀況': '疾患の状況をご説明ください',
  '提交時發生錯誤，請稍後再試': '送信時にエラーが発生しました。しばらくしてから再度お試しください',
  '請閱讀並同意相關規範後再送出': '関連規約をお読みの上、同意してから送信してください',
  '志願服務手冊': 'ボランティア手帳',
  '星期一': '月曜日',
  '星期二': '火曜日',
  '星期三': '水曜日',
  '星期四': '木曜日',
  '星期五': '金曜日',
  '星期六': '土曜日',
  '星期日': '日曜日',
  '09時-12時': '09:00-12:00',
  '13時-16時': '13:00-16:00',
  '跳到中央內容區塊': 'メインコンテンツにスキップ',
  '姓名': '氏名',
}
